// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Pause';

interface PauseProps {
  className?: string;
}

export function Pause({ className }: PauseProps) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={TITLE}
      role="img"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.375 1.59961H6.575V14.3996H2.375V1.59961ZM9.425 1.59961H13.625V14.3996H9.425V1.59961Z"
        fill="currentColor"
      />
    </svg>
  );
}
